import React, { useEffect, useState, useRef } from "react";
import { GoArrowLeft } from "react-icons/go";
import {
  collection,
  query,
  orderBy,
  onSnapshot,
  addDoc,
  doc,
  serverTimestamp,
  setDoc
} from "firebase/firestore";
import { db } from "../firebase";

const ChatWindow = ({ chat, onBack }) => {
  const {
    chatId,
    otherUserId,
    otherUserfName,
    otherUserlName
  } = chat;
console.log("CHAT OBJECT:", chat);

  const currentUser = JSON.parse(localStorage.getItem("user"));
  const currentUserId = String(currentUser?.id);
  const currentUserfName = currentUser?.firstName || "";
  const currentUserlName = currentUser?.lastname || "";
  console.log("hjghjhgkhj;k", currentUserfName.charAt(0))

  const [messages, setMessages] = useState([]);
  const [text, setText] = useState("");

  const chatBodyRef = useRef(null);

  // 🔹 LOAD MESSAGES
  useEffect(() => {
    if (!chatId) return;

    const q = query(
      collection(db, "chats", chatId, "messages"),
      orderBy("createdAt", "asc")
    );

    const unsubscribe = onSnapshot(q, snapshot => {
      const msgs = snapshot.docs.map(d => ({
        id: d.id,
        ...d.data()
      }));

      setMessages(msgs);

      setTimeout(() => {
        if (chatBodyRef.current) {
          chatBodyRef.current.scrollTop =
            chatBodyRef.current.scrollHeight;
        }
      }, 50);
    });

    return () => unsubscribe();
  }, [chatId]);

  // 🔹 SEND MESSAGE
  const sendMessage = async () => {
    if (!text.trim()) return;

    const chatRef = doc(db, "chats", chatId);

    // ensure chat visible to both users
    await setDoc(
      chatRef,
      {
        participants: [currentUserId, String(otherUserId)],
        updatedAt: serverTimestamp(),
        lastMessage: text.trim()
      },
      { merge: true }
    );

    // save message with names
    await addDoc(collection(chatRef, "messages"), {
      text: text.trim(),
      fromId: currentUserId,
      toId: String(otherUserId),
      fromName: `${currentUserfName} ${currentUserlName}`,
      toName: `${otherUserfName} ${otherUserlName}`,
      createdAt: serverTimestamp()
    });

    setText("");
  };
  

  return (
    <>
      <div class="chatrt">
        <div class="chatrtinner">
          <div class="chartrtheading">
            <div class="chatltlistbx">
              {onBack && (
                <button
                  className="btn d-md-none"
                  type="button"
                  onClick={onBack}
                >
                  <GoArrowLeft />
                </button>
              )}
              <div class="chatltlistimg">
                <div className="chatavatar">{otherUserfName.charAt(0)}</div>
                <span class="onlinebadge"></span>
              </div>
              <div class="chatltlistct">
                <h5>{otherUserfName} {otherUserlName}</h5>
                {/* <p>Smart Chat System</p> */}
              </div>
            </div>
          </div>
          <div class="chatbody">
            <div class="chatbodyouter">
              <div className="chatbodyinner" ref={chatBodyRef}>
                {messages.map(msg => {
                  const isMe = msg.fromId === currentUserId;

                  const avatarLetter = msg.fromName
                    ? msg.fromName.charAt(0)
                    : "";

                  return (
                    <div key={msg.id}
                      className={`chatbx ${isMe ? "currentuser" : "other"}`}
                    >
                      <div className="chatbxinner">
                        <div className="chatbximg">
                          {!isMe && (
                            <div className="chatavatar">
                              {avatarLetter}
                            </div>
                          )}

                          {isMe && (
                            <div className="chatavatar">
                              {avatarLetter}
                            </div>
                          )}
                        </div>
                        <div className="chatbxcontent">
                          <div className="chatbxcontentpt">{msg.text}</div>
                          <span className="time">
                            {msg.createdAt?.seconds
                              ? new Date(
                                msg.createdAt.seconds * 1000
                              ).toLocaleTimeString()
                              : ""}
                          </span>
                        </div>
                      </div>
                    </div>

                  );
                })}
              </div>
            </div>
            <div class="chatmsgbx">
              <textarea
                className="form-control"
                value={text}
                onChange={e => setText(e.target.value)}
                placeholder="Type your message..."
              ></textarea>
              <div class="sendmsggroup">
                <button class="sendbtn" type="button" onClick={sendMessage}>
                  <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M16.6285 0.868431L7.87752 9.61862M10.7765 16.4979C10.8069 16.5736 10.8597 16.6383 10.9279 16.6831C10.9961 16.7279 11.0764 16.7509 11.1579 16.7488C11.2395 16.7467 11.3185 16.7197 11.3843 16.6714C11.4501 16.6231 11.4996 16.5559 11.526 16.4787L16.7254 1.28044C16.751 1.20956 16.7559 1.13286 16.7395 1.05931C16.7231 0.985755 16.6861 0.918395 16.6328 0.865108C16.5795 0.811821 16.5122 0.774813 16.4386 0.758412C16.3651 0.742011 16.2884 0.746896 16.2175 0.772497L1.01924 5.9719C0.942042 5.99837 0.874794 6.04782 0.826516 6.11362C0.778239 6.17941 0.751244 6.2584 0.749155 6.33998C0.747065 6.42156 0.769981 6.50183 0.814827 6.57001C0.859672 6.63819 0.924301 6.69102 1.00004 6.72141L7.34331 9.26512C7.54383 9.3454 7.72603 9.46546 7.8789 9.61806C8.03177 9.77066 8.15216 9.95264 8.23281 10.153L10.7765 16.4979Z" stroke="currentColor" stroke-width="1.49768" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ChatWindow;
